<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>
              Confirma que deseja deletar a ação {{ payload.nomeDoArquivo }}?
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col> Essa ação não poderá ser revertida. </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm"
          ><slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { municipioPropostaParcelasAnexoAPI } from "@/apis/proposta";

export default {
  name: "ModalDeletarAcao",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      console.log("this.payload", this.payload);
      municipioPropostaParcelasAnexoAPI
        .remove(this.payload.municipioPropostaParcelaAnexoId)
        .then((_) => {
          this.dialog = false;
          this.$emit("reload");
        })
        .catch((err) => {
          this.$notification.error("Erro ao deletar anexo");
          console.log("Erro no deletar anexo ", err);
          this.setLoading(false);
        });
    },
  },
};
</script>
